import { buildStoreDataUrl, API_CONFIG } from "@/shared/configs/apiConfig.js"
import getSample from '../raws/get.json'

export default {
  url(payload) {
    return buildStoreDataUrl({ service: 'lol', userId: 'lol' })
  },

  parse(raw = {}, payload = {}) {
    // raw = getSample.tickets

    // if (raw?.statusCode !== 200)
    //   return {
    //     statusCode: raw?.statusCode || 500,
    //     message: raw?.message || 'Failed to contact server',
    //     data: null,
    //     raw: null,
    //   }

    // if (!Array.isArray(raw?.data))
    //   return {
    //     statusCode: 400,
    //     message: 'Unexpected data got from server. Expecting Array',
    //     data: null,
    //     raw,
    //   }

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: 4,
        result: levels,
      },
    }
  },
}

const levels = [
  {
    level: 1,
    name: 'Nouveau client',
    description: 'Découvre la plateforme et passe ta première commande.',
    requiredXp: 10,
    rewards: ["Badge 'Premier pas'"],
    milestones: [
      {
        id: 'firstOrder',
        name: 'Première livraison',
        description: 'Terminer ta première commande avec succès.',
        rewardXp: 10,
        icon: '🛵',
        color: '#10B981',
        type: 'order',
      },
    ],
    badge: '🌟',
    color: '#10B981',
    gradient: 'from-green-400 to-emerald-500',
  },
  {
    level: 2,
    name: 'Découvreur',
    description: 'Tu commences à explorer les restaurants autour de toi.',
    requiredXp: 30,
    rewards: ['Réduction de bienvenue', "Badge 'Découvreur'"],
    milestones: [
      {
        id: 'firstOfLevel2',
        name: '2 commandes',
        description: 'Passer au moins 2 commandes.',
        rewardXp: 15,
        icon: '📦',
        color: '#3B82F6',
        type: 'order',
      },
      {
        id: 'ms2-2',
        name: 'Note un restaurant',
        description: 'Laisser une première note sur un restaurant.',
        rewardXp: 15,
        icon: '⭐',
        color: '#F59E0B',
        type: 'review',
      },
    ],
    badge: '🔍',
    color: '#3B82F6',
    gradient: 'from-blue-400 to-indigo-500',
  },
  {
    level: 3,
    name: 'Client actif',
    description: 'Tu prends goût à la livraison et partages tes avis.',
    requiredXp: 60,
    rewards: ["Badge 'Actif'"],
    milestones: [
      {
        id: 'ms3-1',
        name: '3 commandes',
        description: 'Passer 3 commandes terminées.',
        rewardXp: 20,
        icon: '📦',
        color: '#3B82F6',
        type: 'order',
      },
      {
        id: 'ms3-2',
        name: 'Avis client',
        description: 'Laisser ton premier avis détaillé.',
        rewardXp: 20,
        icon: '💬',
        color: '#8B5CF6',
        type: 'review',
      },
      {
        id: 'ms3-3',
        name: 'Plat favori',
        description: 'Ajouter un plat à tes favoris.',
        rewardXp: 20,
        icon: '❤️',
        color: '#EF4444',
        type: 'favorite',
      },
    ],
    badge: '⚡',
    color: '#8B5CF6',
    gradient: 'from-purple-400 to-pink-500',
  },
  {
    level: 4,
    name: 'Client fidèle',
    description:
      'Tu commandes régulièrement et explores de nouveaux restaurants.',
    requiredXp: 100,
    rewards: ["Badge 'Fidèle'"],
    milestones: [
      {
        id: 'ms4-1',
        name: '5 commandes',
        description: 'Passer 5 commandes terminées.',
        rewardXp: 35,
        icon: '📦',
        color: '#3B82F6',
        type: 'order',
      },
      {
        id: 'ms4-2',
        name: 'Nouveaux restaurants',
        description: 'Commander dans 2 restaurants différents.',
        rewardXp: 35,
        icon: '🏪',
        color: '#10B981',
        type: 'restaurant',
      },
      {
        id: 'ms4-3',
        name: 'Recommander un plat',
        description: 'Partager un plat avec un ami.',
        rewardXp: 30,
        icon: '📤',
        color: '#F59E0B',
        type: 'share',
      },
    ],
    badge: '💎',
    color: '#10B981',
    gradient: 'from-emerald-400 to-teal-500',
  },
  {
    level: 5,
    name: 'Explorateur gourmand',
    description:
      "Tu explores de nouvelles saveurs et invites d'autres à te rejoindre.",
    requiredXp: 140,
    rewards: ['Code promo 5%', "Badge 'Explorateur'"],
    milestones: [
      {
        id: 'ms5-1',
        name: '3 catégories',
        description: 'Commander dans 3 catégories de plats différentes.',
        rewardXp: 50,
        icon: '🍽️',
        color: '#EF4444',
        type: 'category',
      },
      {
        id: 'ms5-2',
        name: 'Menu complet',
        description: 'Commander un menu complet (plat + boisson + dessert).',
        rewardXp: 45,
        icon: '🍱',
        color: '#F59E0B',
        type: 'order',
      },
      {
        id: 'ms5-3',
        name: 'Inviter un ami',
        description: 'Inviter un ami à rejoindre la plateforme.',
        rewardXp: 45,
        icon: '👥',
        color: '#3B82F6',
        type: 'referral',
      },
    ],
    badge: '🎯',
    color: '#F59E0B',
    gradient: 'from-primary-400 to-orange-500',
  },
  {
    level: 6,
    name: 'Client régulier',
    description: 'Tu fais partie des utilisateurs les plus constants.',
    requiredXp: 180,
    rewards: ["Badge 'Régulier'"],
    milestones: [
      {
        id: 'ms6-1',
        name: '8 commandes',
        description: 'Passer 8 commandes terminées.',
        rewardXp: 60,
        icon: '📦',
        color: '#3B82F6',
        type: 'order',
      },
      {
        id: 'ms6-2',
        name: 'Dépense 30.000 FCFA',
        description: 'Atteindre une dépense cumulée de 30.000 FCFA.',
        rewardXp: 60,
        icon: '💰',
        color: '#10B981',
        type: 'spending',
      },
      {
        id: 'ms6-3',
        name: '3 notes',
        description: 'Noter au moins 3 restaurants.',
        rewardXp: 60,
        icon: '⭐',
        color: '#F59E0B',
        type: 'review',
      },
    ],
    badge: '🏆',
    color: '#6366F1',
    gradient: 'from-indigo-400 to-purple-500',
  },
  {
    level: 7,
    name: 'Ambassadeur local',
    description:
      "Tu parles de la plateforme autour de toi et inspires d'autres clients.",
    requiredXp: 220,
    rewards: ["Badge 'Ambassadeur'"],
    milestones: [
      {
        id: 'ms7-1',
        name: 'Inviter 2 amis',
        description: "Inviter 2 nouveaux clients à s'inscrire.",
        rewardXp: 55,
        icon: '👥',
        color: '#3B82F6',
        type: 'referral',
      },
      {
        id: 'ms7-2',
        name: 'Partage social',
        description: 'Partager la plateforme sur un réseau social.',
        rewardXp: 55,
        icon: '📱',
        color: '#8B5CF6',
        type: 'social',
      },
      {
        id: 'ms7-3',
        name: '10 commandes',
        description: 'Atteindre 10 commandes complétées.',
        rewardXp: 55,
        icon: '📦',
        color: '#3B82F6',
        type: 'order',
      },
      {
        id: 'ms7-4',
        name: '5 avis positifs',
        description: 'Laisser 5 avis positifs sur des restaurants.',
        rewardXp: 55,
        icon: '👍',
        color: '#10B981',
        type: 'review',
      },
    ],
    badge: '🌟',
    color: '#10B981',
    gradient: 'from-green-400 to-emerald-500',
  },
  {
    level: 8,
    name: 'Adepte des bonnes adresses',
    description: 'Tu connais les meilleurs endroits pour bien manger.',
    requiredXp: 270,
    rewards: ["Badge 'Bon plan'"],
    milestones: [
      {
        id: 'ms8-1',
        name: '5 restaurants',
        description: 'Commander dans 5 restaurants différents.',
        rewardXp: 70,
        icon: '🏪',
        color: '#10B981',
        type: 'restaurant',
      },
      {
        id: 'ms8-2',
        name: 'Plat populaire',
        description: 'Essayer un plat populaire recommandé.',
        rewardXp: 65,
        icon: '🔥',
        color: '#EF4444',
        type: 'trending',
      },
      {
        id: 'ms8-3',
        name: '12 commandes',
        description: 'Atteindre 12 commandes au total.',
        rewardXp: 65,
        icon: '📦',
        color: '#3B82F6',
        type: 'order',
      },
      {
        id: 'ms8-4',
        name: 'Avis photo',
        description: 'Publier un avis avec photo.',
        rewardXp: 70,
        icon: '📸',
        color: '#F59E0B',
        type: 'review',
      },
    ],
    badge: '🍽️',
    color: '#F59E0B',
    gradient: 'from-primary-400 to-yellow-500',
  },
  {
    level: 9,
    name: 'Client Premium',
    description:
      'Tu fais partie du cercle des clients réguliers et recommandés.',
    requiredXp: 320,
    rewards: ["Badge 'Premium'", 'Réduction 10% sur une commande'],
    milestones: [
      {
        id: 'ms9-1',
        name: '15 commandes',
        description: 'Passer 15 commandes au total.',
        rewardXp: 60,
        icon: '📦',
        color: '#3B82F6',
        type: 'order',
      },
      {
        id: 'ms9-2',
        name: '50.000 FCFA',
        description: 'Atteindre 50.000 FCFA de dépenses cumulées.',
        rewardXp: 60,
        icon: '💰',
        color: '#10B981',
        type: 'spending',
      },
      {
        id: 'ms9-3',
        name: '3 invitations',
        description: 'Inviter 3 nouveaux amis.',
        rewardXp: 60,
        icon: '👥',
        color: '#3B82F6',
        type: 'referral',
      },
      {
        id: 'ms9-4',
        name: 'Nouvelle ville',
        description: 'Commander dans une nouvelle ville.',
        rewardXp: 70,
        icon: '🏙️',
        color: '#8B5CF6',
        type: 'location',
      },
      {
        id: 'ms9-5',
        name: 'Badge Fidèle',
        description: "Obtenir le badge 'Fidèle'.",
        rewardXp: 70,
        icon: '💎',
        color: '#6366F1',
        type: 'badge',
      },
    ],
    badge: '👑',
    color: '#6366F1',
    gradient: 'from-indigo-400 to-purple-500',
  },
  {
    level: 10,
    name: 'Client Gold',
    description: "Ton activité exemplaire t'accorde un statut privilégié.",
    requiredXp: 380,
    rewards: ["Badge 'Gold'", 'Livraison prioritaire'],
    milestones: [
      {
        id: 'ms10-1',
        name: '20 commandes',
        description: 'Passer 20 commandes terminées.',
        rewardXp: 70,
        icon: '📦',
        color: '#3B82F6',
        type: 'order',
      },
      {
        id: 'ms10-2',
        name: '10 avis',
        description: 'Laisser au moins 10 avis sur des restaurants.',
        rewardXp: 70,
        icon: '⭐',
        color: '#F59E0B',
        type: 'review',
      },
      {
        id: 'ms10-3',
        name: '3 parrainages validés',
        description: 'Obtenir 3 parrainages confirmés.',
        rewardXp: 70,
        icon: '🤝',
        color: '#10B981',
        type: 'referral',
      },
      {
        id: 'ms10-4',
        name: 'Offre spéciale',
        description: 'Commander via une offre spéciale.',
        rewardXp: 70,
        icon: '🎁',
        color: '#EF4444',
        type: 'offer',
      },
      {
        id: 'ms10-5',
        name: 'Badge Découvreur',
        description: "Obtenir le badge 'Découvreur'.",
        rewardXp: 70,
        icon: '🔍',
        color: '#3B82F6',
        type: 'badge',
      },
    ],
    badge: '🏆',
    color: '#F59E0B',
    gradient: 'from-yellow-400 to-primary-500',
  },
  {
    level: 11,
    name: 'Connaisseur',
    description:
      'Tu maîtrises les bonnes adresses et commandes avec régularité.',
    requiredXp: 450,
    rewards: ["Badge 'Connaisseur'"],
    badge: '🎯',
    color: '#8B5CF6',
    gradient: 'from-purple-400 to-indigo-500',
  },
  {
    level: 12,
    name: 'Membre privilégié',
    description:
      'Tu es désormais un membre reconnu pour ta fidélité et ton engagement.',
    requiredXp: 520,
    rewards: ["Badge 'Privilégié'", 'Réduction 15%'],
    badge: '💎',
    color: '#6366F1',
    gradient: 'from-indigo-400 to-purple-500',
  },
  {
    level: 13,
    name: 'Client influent',
    description: 'Tu inspires les autres à découvrir les meilleures adresses.',
    requiredXp: 600,
    rewards: ["Badge 'Influenceur'"],
    badge: '🌟',
    color: '#10B981',
    gradient: 'from-green-400 to-emerald-500',
  },
  {
    level: 14,
    name: 'Épicurien confirmé',
    description:
      'Tu as goûté à tout et contribues à la réputation de la plateforme.',
    requiredXp: 700,
    rewards: ["Badge 'Épicurien'"],
    badge: '🍽️',
    color: '#F59E0B',
    gradient: 'from-primary-400 to-orange-500',
  },
  {
    level: 15,
    name: 'Client VIP',
    description: 'Tu fais partie des membres les plus fidèles et influents.',
    requiredXp: 820,
    rewards: ["Badge 'VIP'", 'Code promo exclusif'],
    badge: '👑',
    color: '#EF4444',
    gradient: 'from-red-400 to-pink-500',
  },
]
